import { AccountService } from 'src/app/core/services/account.service';
import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    ViewChild,
    ViewChildren,
    QueryList,
    DoCheck,
    ChangeDetectorRef,
    Renderer2,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { Account } from 'src/app/model/account';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';
import { CmsService } from 'src/app/core/services/cms.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticatorService } from 'src/app/core/services/authenticator.service';
import { AccountOTPInfo, OTPViaSMSInfo } from 'src/app/model/authenticator';
import { CmsObject } from 'src/app/model/cmsobject';
import { MiGenParameters } from 'src/app/model/MiGenParameters';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';

@Component({
    selector: 'ms-a2f-configurator',
    templateUrl: './a2f-configurator.component.html',
    styleUrls: ['./a2f-configurator.component.scss'],
})
export class A2fConfiguratorComponent implements OnInit, DoCheck {
    disableSmsSaveButton = true;
    disableQrCodeSaveButton = true;
    separateDialCode = true;
    isComponentInitialized = false;
    showSmsSection = false;
    showQrCodeSection = false;
    loading = false;
    smsSent = false;
    phoneNumberEnabled = false;
    old2FADisabled = false;
    message_1: string;
    message_2: string;
    message_3: string;
    message_4: string;
    message_5: string;
    message_6: string;
    message_7: string;
    message_8: string;
    message_9: string;
    message_10: string;
    message_11: string;
    copyOfMobilePhoneNr: string;
    typeSelected: string = '';
    code: string | number = '';
    emailControl: FormControl;
    @ViewChild('itiPhoneInput') itiPhoneInput: NgxIntlTelInputComponent;
    @ViewChildren('codeInput') _codeInput: QueryList<any>;
    @ViewChildren('phoneInput') _phoneInput: QueryList<any>;
    @ViewChildren('totpCodeInput') _totpCodeInput: QueryList<any>;
    @Output() subKey = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();
    @Input() model: Account;
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    PhoneNumberFormat = PhoneNumberFormat;
    preferredCountries: CountryISO[] = [CountryISO.Italy];
    public placeholder: string;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    image: any;
    imageCached = false;
    public value = 0;
    count = 0;
    phoneForm = new FormGroup({
        phone: new FormControl(undefined, [Validators.required]),
    });
    public cmsObj: CmsObject[];
    language: string;

    constructor(
        public workflow: WorkFlowService,
        private variable: TranslatedVariables,
        private accountService: AccountService,
        private loginService: LoginService,
        public cmsService: CmsService,
        private domSanitizer: DomSanitizer,
        private authenticatorService: AuthenticatorService,
        public serviceUtilsService: ServiceUtilsService,
        public cd: ChangeDetectorRef,
        private renderer: Renderer2
    ) {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
    }

    ngDoCheck() {
        if (this.showSmsSection) {
            this._phoneInput.changes.subscribe(() => {
                if (this._phoneInput.first && !this.smsSent && this.count === 0) {
                    setTimeout(() => {
                        this.count++;
                        this.renderer.selectRootElement('#phone').focus();
                        this.cd.detectChanges();
                    }, 500);
                }
            });
            this._codeInput.changes.subscribe(() => {
                if (this._codeInput.first && this.smsSent) {
                    this._codeInput.first.nativeElement.focus();
                    this.cd.detectChanges();
                }
            });
        }
        if (this.showQrCodeSection) {
            this._totpCodeInput.changes.subscribe(() => {
                if (this._totpCodeInput.first) {
                    this._totpCodeInput.first.nativeElement.focus();
                    this.cd.detectChanges();
                }
            });
        }
    }

    async ngOnInit() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        await this.getCmsObj();
        let opRes = await this.serviceUtilsService.getStoreParameterValue('old2FA');
        let content = new MiGenParameters();
        content = opRes.Content as MiGenParameters;
        this.old2FADisabled = content.Disabled;
        this.loginService.getAccountIfExistsBy(this.authorizationProperties.accountName).subscribe((res) => {
            const opRes: boolean = res.Result;
            if (!opRes) {
                this.workflow.showMessage(this.variable.warningTitle, res.Message);
                return;
            }
            const account: Account = res.Content;
            if (!account) {
                this.workflow.showMessage(this.variable.warningTitle, res.Message);
                return;
            }
            this.model.assign(account);
            this.phoneNumberEnabled = this.model.MobilePhoneNr ? this.model.MobilePhoneNr.length > 0 : false;
            this.copyOfMobilePhoneNr = this.model.MobilePhoneNr ? this.model.MobilePhoneNr : '';
            this.placeholder = this.variable.enterphonenumber + ' *';
            this.isComponentInitialized = true;
        });
    }

    async save(type: number, preferred?: boolean) {
        switch (type) {
            case 1:
                if (!this.old2FADisabled) {
                    this.model.MobilePhonePrefix = this.itiPhoneInput
                        ? this.itiPhoneInput.selectedCountry.dialCode
                        : this.model.MobilePhonePrefix;
                    this.model.MobilePhoneNr = this.itiPhoneInput ? this.itiPhoneInput.phoneNumber : this.model.MobilePhoneNr;
                }
                this.model.TwoFactorType = preferred ? 1 : this.model.TwoFactorType;
                this.loading = true;
                this.saveAccount(this.variable.snackBarSubTitleTwoFactorAuthSms, type);
                break;
            case 2:
                this.model.TwoFactorType = 2;
                this.saveAccount(this.variable.snackBarSubTitleTwoFactorAuthEmail, type);
                break;
            case 4:
                this.model.TwoFactorType = 4;
                this.saveAccount(this.variable.snackBarSubTitleTwoFactorAuthQrCode, type);
                break;
        }
    }

    onClickSubKey(subKey: string) {
        this.subKey.emit(subKey);
    }

    saveAccount(messageSnack: string, twoFactorType: number) {
        const accountOperation = this.accountService.saveAccount(this.model, this.authorizationProperties.accountName).subscribe(
            (accountResult) => {
                if (!accountResult.Result) {
                    this.workflow.showMessage(this.variable.errorSaving, accountResult.Message);
                    accountOperation.unsubscribe();
                    return;
                }
                if (twoFactorType === 1) {
                    this.showSmsSection = false;
                    this.copyOfMobilePhoneNr = this.model.MobilePhoneNr;
                    this.phoneNumberEnabled = true;
                    this.loading = false;
                }
                accountOperation.unsubscribe();
                this.workflow.showSnackBar(this.variable.operationSucceeded, messageSnack);
                this.close.emit(true);
            },
            (err) => {
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.errorSaving, errMess + det);
                accountOperation.unsubscribe();
            }
        );
    }

    getImageOtp() {
        if (!this.imageCached) {
            let message = this.workflow.languageIsItalian() ? 'Unable to get QR code' : 'Impossibile ottenere il codice QR';
            const accountOperation = this.authenticatorService.getImageOtp(this.authorizationProperties.accountName).subscribe(
                (accountResult) => {
                    if (!accountResult) {
                        this.workflow.showMessage(this.variable.warningTitle, message);
                        accountOperation.unsubscribe();
                        return;
                    }
                    let unsafeImageUrl = URL.createObjectURL(accountResult);
                    this.image = this.domSanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
                    this.imageCached = true;
                    accountOperation.unsubscribe();
                },
                (err) => {
                    var errMess = err.statusText;
                    var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                    this.workflow.showMessage(this.variable.warningTitle, message + ': ' + errMess + det);
                    accountOperation.unsubscribe();
                }
            );
        }
    }

    validateTOTP() {
        const validateTOTP = this.authenticatorService
            .validateTOTP(this.authorizationProperties.accountName, this.code.toString())
            .subscribe(
                (result) => {
                    if (!result || !result.Result) {
                        this.workflow.showMessage(this.variable.warningTitle, result.Message);
                        validateTOTP.unsubscribe();
                        return;
                    }
                    validateTOTP.unsubscribe();
                    this.showQrCodeSection = !this.showQrCodeSection;
                    this.model.TOTPConfigured = result.Content.TOTPConfigured;
                    this.code = '';
                    this.workflow.showSnackBar(this.variable.operationSucceeded, '');
                },
                (err) => {
                    var errMess = err.statusText;
                    var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                    this.workflow.showMessage(this.variable.warningTitle, errMess + det);
                    validateTOTP.unsubscribe();
                }
            );
    }

    disableTOTP() {
        const disableTOTP = this.authenticatorService.disableTOTP(this.authorizationProperties.accountName).subscribe(
            (result) => {
                if (!result || !result.Result) {
                    this.workflow.showMessage(this.variable.warningTitle, result.Message);
                    disableTOTP.unsubscribe();
                    return;
                }
                disableTOTP.unsubscribe();
                this.imageCached = false;
                this.model.TwoFactorType = result.Content.TwoFactorType;
                this.model.TOTPConfigured = result.Content.TOTPConfigured;
                this.workflow.showSnackBar(this.variable.operationSucceeded, '');
            },
            (err) => {
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.warningTitle, errMess + det);
                disableTOTP.unsubscribe();
            }
        );
    }

    validateSMS() {
        let obj: OTPViaSMSInfo = new OTPViaSMSInfo();
        obj.AccountName = this.authorizationProperties.accountName;
        obj.InternationalPrefix = this.itiPhoneInput.selectedCountry.dialCode;
        obj.PhoneNumber = this.model.MobilePhoneNr;
        obj.Otp = this.code.toString();
        const validateSMS = this.authenticatorService.validateSMS(obj).subscribe(
            (result) => {
                if (!result || !result.Result) {
                    this.workflow.showMessage(this.variable.warningTitle, result.Message);
                    validateSMS.unsubscribe();
                    return;
                }
                validateSMS.unsubscribe();
                this.showSmsSection = !this.showSmsSection;
                this.disableSmsSaveButton = true;
                this.smsSent = false;
                this.code = '';
                let content: AccountOTPInfo = result.Content;
                this.model.TwoFactorType = content.TwoFactorType;
                this.model.TOTPConfigured = content.TOTPConfigured;
                this.model.MobilePhoneNr = content.MobilePhoneNr;
                this.model.MobilePhonePrefix = content.MobilePhonePrefix;
                this.copyOfMobilePhoneNr = content.MobilePhoneNr;
                this.phoneNumberEnabled = true;
                this.workflow.showSnackBar(this.variable.operationSucceeded, '');
            },
            (err) => {
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.warningTitle, errMess + det);
                validateSMS.unsubscribe();
            }
        );
    }

    disableSMS() {
        const disableSMS = this.authenticatorService.disableSMS(this.authorizationProperties.accountName).subscribe(
            (result) => {
                if (!result || !result.Result) {
                    this.workflow.showMessage(this.variable.warningTitle, result.Message);
                    disableSMS.unsubscribe();
                    return;
                }
                disableSMS.unsubscribe();
                let content: AccountOTPInfo = result.Content;
                this.model.TwoFactorType = content.TwoFactorType;
                this.model.TOTPConfigured = content.TOTPConfigured;
                this.model.MobilePhoneNr = '';
                this.phoneForm.controls['phone'] = new FormControl(undefined, [Validators.required]);
                this.copyOfMobilePhoneNr = '';
                this.workflow.showSnackBar(this.variable.operationSucceeded, '');
                this.disableSmsSaveButton = true;
                this.phoneNumberEnabled = false;
                this.showSmsSection = false;
            },
            (err) => {
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.warningTitle, errMess + det);
                disableSMS.unsubscribe();
            }
        );
    }

    configureSMS() {
        let obj: OTPViaSMSInfo = new OTPViaSMSInfo();
        obj.AccountName = this.authorizationProperties.accountName;
        obj.InternationalPrefix = this.itiPhoneInput.selectedCountry.dialCode;
        obj.PhoneNumber = this.itiPhoneInput.phoneNumber.replace(/\s/g, '');
        obj.Otp = '';
        this.loading = true;
        this.smsSent = false;
        const configureSMS = this.authenticatorService.otpSMSConfiguration(obj).subscribe(
            (result) => {
                if (!result || !result.Result) {
                    this.loading = false;
                    this.smsSent = false;
                    this.workflow.showMessage(this.variable.warningTitle, result.Message);
                    configureSMS.unsubscribe();
                    return;
                }
                this.workflow.showSnackBar(this.variable.operationSucceeded, '');
                this.model.MobilePhoneNr = obj.PhoneNumber;
                this.model.MobilePhonePrefix = obj.InternationalPrefix;
                this.loading = false;
                this.smsSent = true;
                this.disableSmsSaveButton = false;
                configureSMS.unsubscribe();
            },
            (err) => {
                this.loading = false;
                this.smsSent = false;
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.warningTitle, errMess + det);
                configureSMS.unsubscribe();
            }
        );
    }

    edit() {
        this.showSmsSection = !this.showSmsSection;
        this.phoneForm.controls['phone'] = new FormControl(undefined, [Validators.required]);
    }

    cancelSMS() {
        this.showSmsSection = !this.showSmsSection;
        this.count = 0;
        this.code = '';
        this.smsSent = false;
        this.disableSmsSaveButton = true;
        this.phoneForm.controls['phone'] = new FormControl(undefined, [Validators.required]);
    }

    async getCmsObj() {
        let language = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(language, 'mfa');
        this.message_1 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_1').ContentTranslation;
        this.message_2 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_2').ContentTranslation;
        this.message_3 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_3').ContentTranslation;
        this.message_4 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_4').ContentTranslation;
        this.message_5 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_5').ContentTranslation;
        this.message_6 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_6').ContentTranslation;
        this.message_7 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_7').ContentTranslation;
        this.message_8 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_8').ContentTranslation;
        this.message_9 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_9').ContentTranslation;
        this.message_10 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_10').ContentTranslation;
        this.message_11 = this.cmsObj.find((x) => x.ContentName == 'mfa.message_11').ContentTranslation;
    }
}
